import { Component } from '@angular/core';

@Component({
  selector: 'app-play-store',
  imports: [],
  templateUrl: './playstore.html',
  styleUrl: './playstore.scss',
})
export class PlayStore {

}
